<template>
    <div v-if="provvigioniConfig.length > 0">
        <div class="form-group">
            <label>
                <localized-text localizedKey="Qualifica provvigioni" text="Qualifica provvigioni"></localized-text>
            </label>
            <select class="form-control" v-model="selectedProvvigioni" @change="onSelectedProvvigioniChange">
                <option v-for="(item, i) in provvigioniConfig" :key="i" :value="item">
                    {{item.qualificationCode}}
                </option>
            </select>
        </div>
        <div class="scrollListContainer">
            <localized-text localizedKey="Storico qualifiche" text="Storico qualifiche"></localized-text>
            <div class="scrollListItem d-flex justify-content-start" v-for="(item, i) in localValue.qualifications" :key="i">
                <div class="text-cyan">{{$filters.date(item.date, "DD-MM-YYYY HH:mm")}}</div> 
                <div class="ms-2">
                    {{item.qualificationCode}}
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model'
import { mixins, Options } from 'vue-class-component';
import WithModel from '@/mixins/withModel'
import { QualificationConfigClient } from '@/services/Services';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class qualification extends mixins(WithModel) {

    selectedProvvigioni: OM.QualificationConfig = null;
    provvigioniConfig: OM.QualificationConfig[] = [];

    declare localValue: OM.Lead;

    created(){
        QualificationConfigClient.getQualifiche()
        .then(x => {
            this.provvigioniConfig = x;
            if(this.localValue){
                this.selectedProvvigioni = this.provvigioniConfig.find(x => this.localValue.qualifications[0] && x.qualificationCode == this.localValue.qualifications[0].qualificationCode);
            }
        })
    }

    onSelectedProvvigioniChange(){
        if(!this.localValue.qualifications){
            this.localValue.qualifications = [];
        }
        this.localValue.qualifications[0] = {
            date: new Date().toISOString(),
            qualificationCode: this.selectedProvvigioni.qualificationCode
        }
    }


}
</script>
<style scoped>
</style>
